import { OAuthService } from "../features/oauth/oauth-service";
import { LOCAL_STORAGE_TOKEN_KEY } from "../ui/setup-view";
export var Endpoints;
(function (Endpoints) {
    Endpoints["registrations"] = "/v2/registrations";
    Endpoints["operations"] = "/v2/operations";
    Endpoints["auditLog"] = "/v2/audit/log";
})(Endpoints || (Endpoints = {}));
var Method;
(function (Method) {
    Method["GET"] = "GET";
    Method["PUT"] = "PUT";
    Method["POST"] = "POST";
    Method["DELETE"] = "DELETE";
})(Method || (Method = {}));
export const makeAuthPutRequest = async (path, params, payload) => {
    return makeAuthRequest(Method.PUT, path, params, payload);
};
export const makeAuthPostRequest = async (path, params, payload) => {
    return makeAuthRequest(Method.POST, path, params, payload);
};
export const makeAuthGetRequest = async (path, params) => {
    return makeAuthRequest(Method.GET, path, params);
};
export const makeAuthDeleteRequest = async (path, params = null) => {
    return makeAuthRequest(Method.DELETE, path, params);
};
const makeAuthRequest = async (method, path, params = null, payload = null) => {
    const searchParams = params ? new URLSearchParams(params) : null;
    try {
        const token = await getToken();
        const requestInit = {
            method,
            headers: getHeaders(token),
            ...(payload && { body: JSON.stringify(payload) }),
        };
        const url = `${getBaseUrl()}${path}?${searchParams}`;
        const response = await fetch(url, requestInit);
        // TODO make sure is it ok to consider response.ok as a source of truth even for API Response.status
        if (response.ok) {
            // Happy path
            const data = await response.json();
            return {
                response: data
            };
        }
        // Handle API errors
        // Unauthorized
        if (response.status === 401) {
            // Unauthorized alert will be visible, redirect to login page
            window.location.href = "/#";
            return createApiError(response.status, "Unauthorized access. Please login again.");
        }
        // Forbidden access
        if (response.status === 403) {
            return createApiError(response.status, "Insufficient rights to perform operation", "The request requires higher privileges than provided by the access token.");
        }
        // other errors
        const errorResponse = await response.json();
        return {
            apiError: {
                status: errorResponse.status ?? response.status,
                responseObject: errorResponse?.responseObject,
            },
        };
    }
    catch (error) {
        // Handle non-API errors
        return {
            error: error instanceof Error ? error : new Error(`Request failed: ${error}`),
        };
    }
};
function getBaseUrl() {
    const baseApiUrl = process.env.API_URL;
    if (!baseApiUrl) {
        throw new Error("API URL is missing in ENV variable");
    }
    return baseApiUrl;
}
function getHeaders(token) {
    return {
        "Content-Type": "application/json",
        "Accept": "*/*",
        "Accept-Encoding": "gzip, deflate, br",
        ...(token ? { "Authorization": token } : {})
    };
}
async function getToken() {
    // if OAuth is enabled, check OAuthService
    if (OAuthService.isOAuthEnabled) {
        const token = await OAuthService.getInstanceOrThrow().getToken();
        return `Bearer ${token}`;
    }
    else {
        // return token stored in LocalStorage for development purposes
        return localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY) ?? "";
    }
}
const createApiError = (status, message, logErrorMessage) => ({
    apiError: {
        status: String(status),
        responseObject: {
            code: String(status),
            message,
        },
    },
    // error which will be displayed as a Message in Error Log
    ...(logErrorMessage && {
        error: new Error(logErrorMessage),
    }),
});
